module.exports = __webpack_public_path__ + "img/pd-img11.d68ee95d.png";